import React,{useState} from 'react';
import { useNavigate } from 'react-router-dom';

export default function AccountTypeSelector() {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState(null); 
     const handleSelect = (type) => {
    setSelectedType(type);
  };
  
  const handleContinue = () => {
    if (selectedType === "individual") {
      navigate("/register/individual");
    } else if (selectedType === "business") {
      navigate("/register/business");
    }
  };

  return (
    <div className="min-h-screen w-full bg-white flex flex-col">
      {/* Header with logo */}
      <div className="w-full border-b border-[#0B214E33] py-6 px-6 flex items-center justify-between">
        {/* FXMaster Logo (left) */}
        <img src="/fx_logo_old.png" alt="FXMaster Logo" className="w-[160px]" />

        {/* Back to Login (right) */}
        <button
           onClick={() => navigate("/business/")}
          className="px-4 py-2 rounded-lg bg-[#0B214E] text-white font-medium hover:bg-[#091a3a] transition"
        >
          Back To Login
        </button>
      </div>
      {/* Main content */}
      <div className="flex-grow flex flex-col items-center justify-center px-4">
        {/* Heading */}
        <h1 className="text-[#0B214E] text-xl sm:text-2xl font-semibold text-center mb-12 max-w-xl">
          Start your application by selecting the account type you need.
        </h1>

        {/* Cards */}
        <div className="flex flex-col md:flex-row gap-8 justify-center items-center w-full max-w-5xl">
          {/* Individual Account Card */}
          <div
            onClick={() => handleSelect("individual")}
             className={`relative text-white rounded-2xl overflow-hidden w-[300px] h-[350px] cursor-pointer hover:scale-105 transition-transform shadow-lg ${
              selectedType === "individual"
                ? "bg-[#091a3a] border-4 border-[#4DA6FF] shadow-2xl scale-105 ring-4 ring-blue-400/40"
                : "bg-[#0B214E] border border-transparent hover:scale-105 shadow-lg"
            }`}
          >
            {/* Top icon */}
            <img
              src="/icons/ind-icon.svg"
              alt="icon"
              className="absolute top-4 left-4 w-16 h-16 z-10"
            />

            {/* Background image */}
            <img
              src="./individual-account.png"
              alt="background"
              className="w-full h-full object-cover opacity-30"
            />

            {/* Overlay content */}
            <div className="absolute inset-0 flex flex-col justify-end p-6 z-20">
              <h2 className="text-lg mb-1">Individual Account</h2>
              <p className="text-sm leading-snug">
                Who are purchasing, selling, or transferring funds
                internationally.
              </p>
              <div className="mt-4 self-end">
                <img
                  src="/icons/red-arrow.svg"
                  alt="arrow"
                  className="w-8 h-8"
                />
              </div>
            </div>
          </div>

          {/* Business Account Card */}
          <div
            onClick={() => handleSelect("business")}
            className={`relative text-white rounded-2xl overflow-hidden w-[300px] h-[350px] cursor-pointer hover:scale-105 transition-transform shadow-lg ${
              selectedType === "business" 
                  ? "bg-[#091a3a] border-4 border-[#4DA6FF] shadow-2xl scale-105 ring-4 ring-blue-400/40"
                  : "bg-[#0B214E] border border-transparent hover:scale-105 shadow-lg"
            }`}
          >
            {/* Top icon */}
            <img
              src="/icons/bus-icon.svg"
              alt="icon"
              className="absolute top-4 left-4 w-16 h-16 z-10"
            />

            {/* Background image */}
            <img
              src="./business-account.png"
              alt="background"
              className="w-full h-full object-cover opacity-30"
            />

            {/* Overlay content */}
            <div className="absolute inset-0 flex flex-col justify-end p-6 z-20">
              <h2 className="text-lg mb-1">Business Account</h2>
              <p className="text-sm leading-snug">
                Who are affected by fluctuations in currency exchange markets.
              </p>
              <div className="mt-4 self-end">
                <img
                  src="/icons/red-arrow.svg"
                  alt="arrow"
                  className="w-8 h-8"
                />
              </div>
            </div>
          </div>
           
        </div>
            {selectedType && (
          <div className="mt-10">
            <button
              onClick={handleContinue}
              className="px-8 py-3 bg-[#0B214E] text-white rounded-lg font-medium hover:bg-[#091a3a] transition"
            >
              Continue
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
